import React from 'react'
import { Link } from 'react-router-dom'
import { FaWhatsapp } from "react-icons/fa";

const Footer = () => {
  return (
    <>
      <div className="sticky-watsapp">

        <a href="https://api.whatsapp.com/send?phone=971566265785" className="btn-whatsapp-pulse btn-whatsapp-pulse-border">
          {/* <i className="fab fa-whatsapp"></i> */}
          <FaWhatsapp color='white' />
        </a>
      </div>

      <div className="section-8 gap">
        <div className="text">Luxury awaits you at the sea...</div>
      </div>

      <footer className="">
        <div className="bg-color">
          <div className="container">
            <div className="row d-flex justify-content-center align-items-start">
              <div className="col-lg-3 mb-lg-0 mb-3 d-lg-flex justify-content-center">
                <div>
                  <img src="/assets/images/white-logo.png" alt="logo" className="logo" />
                  <p className='mt-3'>
                  Blue Harbour |  Luxury Yacht Rental Dubai- Experience premium Dubai Marina Yacht Rental for celebrations, birthday parties, corporate events and private cruises. Book your yacht today!

                  </p>
                </div>
              </div>
              <div className="col-lg-3 mb-lg-0 mb-3">
                <div>
                  <h3>Contact</h3>
                  <div className="d-flex">
                    <i className="fa-solid fa-location-dot mt-1"></i>
                    <address className="float-lg-end">
                    Blue Harbour Yachts, <br />
                    Dubai Marina - Dubai - United Arab Emirates
                    </address>
                  </div>
                  <p>
                    <i className="fa-solid fa-phone"></i>
                    <a href="tel:+971566265785">+971 56 626 5785</a>
                  </p>
                  <p>
                    <i className="fa-solid fa-envelope"></i>
                    <a href="mailto:support@blueharbouryachts.com">support@blueharbouryachts.com</a>
                  </p>

           <p>
             <Link to="terms-and-condition">Terms & Conditions</Link> |
            <Link to="privacy-policy"> Privacy Policy</Link>
           </p>

                </div>
              </div>
              <div className="col-lg-2 mb-lg-0 mb-3">
                <div className="social-icons">
                  <h3>Follow Us</h3>
                  <a href="https://www.facebook.com/people/Blue-harbour-Yachts-LLC/61552064004905/"><i className="fa-brands fa-facebook"></i> Facebook</a>
                  <a href="https://www.instagram.com/blueharbouryachts/"><i className="fa-brands fa-instagram"></i> Instagram</a>
                  <a href="https://www.youtube.com/@BlueHarbouryachts"><i className="fa-brands fa-youtube"></i> Youtube</a>
                </div>
              </div>

              <div className="col-lg-4 mb-lg-0 mb-3 d-flex justify-content-start">
                <div className="mapouter">
                  <div className="gmap_canvas">
                    <iframe className="gmap_iframe" frameBorder={0} scrolling="no" marginHeight="0" marginWidth="0"
                      src="https://www.google.com/maps/embed/v1/place?q=Blue+Harbour+Yachts+Dubai+Marina+-+Dubai+-+United+Arab+Emirates&key=AIzaSyBFw0Qbyq9zTFTd-tUY6dZWTgaQzuU17R8"></iframe>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="footer-text">
          <p>
            Payment Method We Accept

<img src="/visa.webp" alt="Visa Card Logo" className='ms-3' />
<img src="/mastercard.webp" alt="Master Card Logo" />

<img src="/unionpay.webp" alt="Unionpay Logo" />

<img src="/bitcoin.webp" alt="Bitcoin Logo" />

<img src="/Ethereum.webp" alt="Ethereum Logo" />

<img src="/Litecoin.webp" alt="Litecoin Logo" />
<img src="/sepa.webp" alt="SEPA Logo" />

          </p>
        <div>
    <p>
                       @2025 Blue Harbour Yachts. All Rights Reserved.

    </p>
        </div>
        </div>
      </footer>
    </>
  )
}

export default Footer